import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common'
import { HelperService } from './helper.service';
import { ErroServidor } from '../models/erro-servidor.model';
import { ErroApp } from '../models/erro-app.model';
import { MensagemConstante } from '../constants';
import { CodigoErroConstante } from '../constants/codigo-erro.constant';

@Injectable()
export class ErrorHandlerService {

  constructor(
    protected helperService: HelperService,
    protected datePipe: DatePipe) {
  }


  public ehNivelInvalidoGovBR(error: ErroApp): boolean{
      return error.codigoErro != null && (error.codigoErro.toLowerCase() == CodigoErroConstante.GOVBR_NIVEL_INVALIDO.toLowerCase());
  }

  public ehSessaoGovBrExpirada(error: ErroApp): boolean {
    return error.codigoErro != null && error.codigoErro.toLowerCase() == CodigoErroConstante.SESSAO_GOVBR_EXPIRADA.toLocaleLowerCase();
  }

  public createErrorApp(responseError: HttpErrorResponse | any)
  {
      let erroJaProcessado =  responseError instanceof ErroApp;
      let dataOcorrencia = this.datePipe.transform(new Date(), 'yyyyMMdd.HHmmss.sss');

      if (erroJaProcessado)
      {
            return responseError;
      }

      if (responseError.status)
      {
        switch (responseError.status)
        {
          case 401:
            return new ErroApp("", `[${responseError.status}/S${dataOcorrencia}] ${MensagemConstante.msgErroClientSideAcessoNegado}`, MensagemConstante.msgErroClientSideRodape, null);

          case 404:
            return new ErroApp("", `[${responseError.status}/S${dataOcorrencia}] Recurso não encontrado`, MensagemConstante.msgErroClientSideRodape, [responseError.message]);
        }
      }

      if (!(responseError instanceof HttpErrorResponse))
      {
        return new ErroApp("", `[100/C${dataOcorrencia}]`, MensagemConstante.msgErroClientSideRodape, [responseError]);
      }

      let erro: ErroServidor = responseError.error;
      if (!erro)
      {
        return new ErroApp("", `[${responseError.status}/C${dataOcorrencia}]`,MensagemConstante.msgErroClientSideRodape,  [responseError.message]);
      }


      if (erro.id)
      {
          let contemListaDeErros =  this.helperService.ehArrayComItens(erro.listaDeErros);
          if (contemListaDeErros)
          {
            return new ErroApp(erro.codigo, `[${responseError.status}/S${erro.id}] ${erro.mensagem}.`, MensagemConstante.msgErroClientSideRodape, erro.listaDeErros);
          }
          else
          {
            return  new ErroApp(erro.codigo, `[${responseError.status}/S${erro.id}]`, MensagemConstante.msgErroClientSideRodape, [`${erro.mensagem}`]);
          }
      } else
      {
          let dataOcorrencia = this.datePipe.transform(new Date(), 'yyyyMMdd.HHmmss.sss');
          return new ErroApp("", `[${responseError.status}/SC${dataOcorrencia}]`, MensagemConstante.msgErroClientSideRodape, [responseError.error]);
      }
    }
}
